/** Agent-interface accounts: customer-tenant users whose app_type is set by
 * Users & Groups. They belong to /agent/* only, never the control plane. */
export function isAgentAccount(u) {
  return u?.role === "customer" && (u?.app_type === "agent" || u?.app_type === "manager");
}
